var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPermissions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 6,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_41276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.1707 21.605C25.0583 21.605 27.4077 19.2555 27.4077 16.3679V15.0535C27.4077 12.1658 25.0583 9.81641 22.1707 9.81641C19.283 9.81641 16.9336 12.1555 16.9336 15.0431V16.3576C16.9336 19.2452 19.283 21.5946 22.1707 21.5946V21.605ZM19.0036 15.0535C19.0036 13.3043 20.4215 11.8864 22.1707 11.8864C23.9198 11.8864 25.3377 13.3043 25.3377 15.0535V16.3679C25.3377 18.117 23.9198 19.535 22.1707 19.535C20.4215 19.535 19.0036 18.117 19.0036 16.3679V15.0535Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8172 21.6467C26.1237 21.3362 25.3475 21.3776 24.7368 21.7502C23.1843 22.7024 21.1557 22.7024 19.6033 21.7502C18.9926 21.3776 18.2164 21.3362 17.5229 21.6467C14.7698 22.8784 13 25.6211 13 28.6329V31.148C13 32.214 13.8694 33.0834 14.9354 33.0834H29.415C30.481 33.0834 31.3504 32.214 31.3504 31.148V28.6329C31.3504 25.6211 29.5702 22.8784 26.8275 21.6467H26.8172ZM29.2701 31.0134H15.07V28.6329C15.07 26.4388 16.3637 24.4309 18.3716 23.5304C18.4544 23.489 18.5062 23.4994 18.5165 23.4994C20.721 24.8552 23.619 24.8552 25.8132 23.4994C25.8236 23.4994 25.8857 23.4994 25.9685 23.5201C27.9763 24.4205 29.2701 26.4181 29.2701 28.6226V31.0031V31.0134Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6063 18.8844H31.8261V17.1042C31.8261 16.8869 31.6501 16.7109 31.4328 16.7109H30.139C29.9217 16.7109 29.7458 16.8869 29.7458 17.1042V18.8844H27.9656C27.7482 18.8844 27.5723 19.0604 27.5723 19.2777V20.5715C27.5723 20.7888 27.7482 20.9648 27.9656 20.9648H29.7458V22.7449C29.7458 22.9623 29.9217 23.1382 30.139 23.1382H31.4328C31.6501 23.1382 31.8261 22.9623 31.8261 22.7449V20.9648H33.6063C33.8236 20.9648 33.9996 20.7888 33.9996 20.5715V19.2777C33.9996 19.0604 33.8236 18.8844 33.6063 18.8844Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_41276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 23.277,
    fill: "white",
    transform: "translate(13 9.80664)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPermissions);
export default __webpack_public_path__ + "static/media/Permissions.fbb26269c9aa6b181603eac2ad75ad84.svg";
export { ForwardRef as ReactComponent };